module.exports = __webpack_public_path__ + "img/30b-indicadores-osm-mapa-pontos.584d82da.png";